import { configureStore, createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    token: localStorage.getItem('access_token') || null,
    refreshToken: localStorage.getItem('refresh_token') || null,
  },
  reducers: {
    loginSuccess(state, action) {
      state.user         = action.payload.user;
      state.token        = action.payload.access_token;
      state.refreshToken = action.payload.refresh_token;
      localStorage.setItem('access_token',  action.payload.access_token);
      localStorage.setItem('refresh_token', action.payload.refresh_token);
      localStorage.setItem('user',          JSON.stringify(action.payload.user));
    },
    logout(state) {
      state.user         = null;
      state.token        = null;
      state.refreshToken = null;
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user');
    },
  },
});

const marketSlice = createSlice({
  name: 'market',
  initialState: { selectedMarket: 'india', liveQuotes: {}, loading: false },
  reducers: {
    setSelectedMarket(state, action) { state.selectedMarket = action.payload; },
  },
});

const portfolioSlice = createSlice({
  name: 'portfolio',
  initialState: { portfolios: [], selectedPortfolio: null, holdings: [], loading: false },
  reducers: {
    setPortfolios(state, action)        { state.portfolios        = action.payload; },
    setSelectedPortfolio(state, action) { state.selectedPortfolio = action.payload; },
    setHoldings(state, action)          { state.holdings          = action.payload; },
  },
});

export const { loginSuccess, logout }       = authSlice.actions;
export const { setSelectedMarket }          = marketSlice.actions;
export const { setPortfolios, setHoldings } = portfolioSlice.actions;

export const store = configureStore({
  reducer: {
    auth:      authSlice.reducer,
    market:    marketSlice.reducer,
    portfolio: portfolioSlice.reducer,
  },
});
